class BuyerHandler {
  constructor(baseURL, basicUsername, basicPassword) {
    this.baseURL = baseURL;
    this.basicUsername = basicUsername;
    this.basicPassword = basicPassword;
  }

  getAuthorizationHeader() {
    const credentials = `${this.basicUsername}:${this.basicPassword}`;
    const base64Credentials = btoa(credentials);
    return {
      "Content-Type": "application/json",
      "Authorization": `Basic ${base64Credentials}`,
      Accepts: "application/json",
    };
  }
  
  async getBuyerById(buyerId) {
    try {
      const response = await fetch(`${this.baseURL}/buyer/${buyerId}`, {
        method: "GET",
        headers: this.getAuthorizationHeader(),
      });
      const json = await response.json();
      if (response.ok) {
        return json;
      }
    } catch (error) {
      console.log("Backend not reachable", error);
    }
  }

  async createBuyer(body) {
    try {
      const response = await fetch(`${this.baseURL}/buyer/`, {
        method: "POST",
        headers: this.getAuthorizationHeader(),
        body: JSON.stringify(body),
      });
      const json = await response.json();
      if (response.ok) {
        return json;
      }
    } catch (error) {
      console.log("Backend not reachable", error);
    }
  }

  async deleteBuyer(buyerId) {
    console.log(buyerId);
    console.log(`${this.baseURL}/buyer/${buyerId}`);
    
    try {
        const response = await fetch(`${this.baseURL}/buyer/${buyerId}`, {
            method: "DELETE",
            headers: this.getAuthorizationHeader(),
        });
        const json = await response.json();
        if (response.ok) {
            return json;
        }
    } catch (error) {
        console.log("Backend not reachable", error);
    }
}
}

export default BuyerHandler;